import { Shark } from "shark-mvc";

import ManagerBase from "./ManagerBase";

class VolumeCollectionManager extends ManagerBase {
	constructor () {
		super("volumeCollectionManager");
		this.remoteClassName = "volume-collection";
	}
}

const volumeCollectionManager = new VolumeCollectionManager();

Shark.registerController(volumeCollectionManager);

export default volumeCollectionManager;
